import React, { Fragment, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Col, Image } from "antd";
import { EyeOutlined, LeftOutlined } from "@ant-design/icons";
import './style.scss';

export const BackButton = () => {
    return (
        <>
            <Col style={{ marginLeft: "10px", paddingTop: '10px' }}>
                <Link to='' onClick={() => window.history.back()} ><LeftOutlined /> Back</Link>
            </Col>
        </>
    );
};

export const TableTitleImage = (props: any) => {
    const { image, title, id } = props;
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const styles = {
        container: {
            display: 'flex',
            alignItems: 'center',
            gap: isMobile ? '8px' : '16px',
        },
        image: {
            height: isMobile ? '30px' : '50px',
            width: isMobile ? '50px' : '70px',
            borderRadius: 10,
            objectFit: 'cover' as React.CSSProperties['objectFit'],
        },
        fallbackContainer: {
            width: isMobile ? '50px' : '70px',
            height: isMobile ? '35px' : '50px',
        },
        title: {
            fontSize: isMobile ? '12px' : '14px',
            lineHeight: isMobile ? '18px' : '22px',
            fontWeight: 600,
            color: '#171A1FFF',
            wordWrap: 'break-word' as const,
            maxWidth: isMobile ? '120px' : '180px',
        },
    };

    return (
        <Fragment key={id}>
            <div style={styles.container}>
                {image && typeof image === 'string' ? (
                    <Image
                        preview={{
                            mask: <EyeOutlined />,
                            rootClassName: 'preview-radius',
                        }}
                        src={image}
                        style={styles.image}
                    />
                ) : (
                    <div style={styles.fallbackContainer}>{image}</div>
                )}
                <span style={styles.title}>{title}</span>
            </div>
        </Fragment>
    );
};

export const TableAction = (status?: any) => {
    return [
        {
            key: "Edit",
            label: "Edit"
        },
        {
            key: status,
            label: status
        },
    ];
};

export const TableActionEditOrDelete = (key: string, id: number, navigate: ReturnType<typeof useNavigate>, path: string, value?: any, UpdateState?: any, States?: any): any => {
    switch (key) {
        case "Delete": {
            const filtered = States?.filter((item: any) => item.id !== id);
            UpdateState(filtered);
        }
            break;

        case "Edit":

            break;

        case "Enable":
        case "Disable": {
            const updated = States.map((item: any) => {
                if (item.id === id) {
                    return { ...item, status: key };
                }
                return item;
            });
            UpdateState(updated);
        }
            break;
    }
};

export const tableHeightResponsive = () => {
    const heights = window.innerWidth <= 500 ? 255 : 210;
    const [tableHeight, setTableHeight] = useState<number>(window.innerHeight - heights);


    useEffect(() => {
        const handleResize = () => {
            setTableHeight(window.innerHeight - heights);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    return tableHeight;
};